jQuery(document).ready(function() {
  $('.search-icon').on('click', function(e) {
    e.stopPropagation();
    $('.search-box-bottom').find('input[type="text"]').focus();
  });
  $('.search-icon').on('click', function() {
    $('.search-box-bottom').fadeToggle(300).toggleClass('open');
  });
});

$(function() {
  var currentAjaxRequest = null;
  var searchForms = $('form[action="/search"]').css('position', 'relative').each(function() {
    var input = $(this).find('input[name="q"]');
    var offSet = input.position().top + input.innerHeight();
    $('<ul class="search-results"></ul>').css({ 'position': 'absolute', 'left': '0px' }).appendTo($(this)).hide();    

    input.attr('autocomplete', 'off').bind('keyup change', function() {
      var term = $(this).val();
      var form = $(this).closest('form');
      var searchURL = '/search?type=product&q=' + term;
      var resultsList = form.find('.search-results');

      if (term.length >= 2 && term != $(this).attr('data-old-term')) {
        $(this).attr('data-old-term', term);
        if (currentAjaxRequest != null) currentAjaxRequest.abort();

        currentAjaxRequest = $.getJSON(searchURL + '&view=json', function(data) {
          resultsList.empty();

          if (data.results_count == 0) {
            resultsList.hide();
          } else {
            $.each(data.results, function(index, item) {
              if (item['data-available'] === true) {
                var link = $('<a></a>').attr('href', item.url);
                link.append('<span class="thumbnail"><img src="' + item.thumbnail + '" /></span>');
                link.append('<span class="title">' + item.title + '</span>');
                if (item.subtitle !== null) {
                  link.append('<span class="subtitle">' + item.subtitle + '</span>');
                }              
                link.wrap('<li></li>');
                var listItem = link.parent();
                listItem.attr('data-available', item['data-available']);
                resultsList.append(listItem);
              }
            });

            if (data.results_count > 10) {
              resultsList.append('<li><span class="title see-all"><a href="' + searchURL + '">See all results (' + data.results_count + ')</a></span></li>');
            }

            if (resultsList.children().length > 0) {
              resultsList.fadeIn(200);
            } else {
              resultsList.hide();
            }
          }        
        });
      } else if (term.length < 2) {
        resultsList.hide();
      }
    });
  });

  $('body').bind('click', function() {
    $('.search-results').hide();
  });
});

var links = document.links;
for (let i = 0, linksLength = links.length; i < linksLength; i++) {
  if (links[i].hostname !== window.location.hostname && links[i].hostname !== '') {
    links[i].target = '_blank';
    links[i].rel = 'noreferrer noopener';
  }
}

$(document).ready(function() {
  $(".share-menu-toggle").click(function() {
    $(".share-menu").toggleClass("open");
  });
});

$('a.search-icon').click(function(e) {
  e.preventDefault();
});